export enum WishlistMode {
  Off = "Off",
  Curated = "Curated",
  Custom = "Custom",
}

export interface IWishlistLinkResponse {
  url?: string
  label?: string
  domain?: string
  key?: string
}

export interface ICuratedWishlistGroupResponse {
  provider?: string
  baseUrl?: string
  providerAssetUrl?: string
  items?: IWishlistLinkResponse[] | null
}

export interface IWishlistResponse {
  wishlistMode?: WishlistMode
  availableModes?: WishlistMode[] | null
  links?: IWishlistLinkResponse[] | null
  curated?: ICuratedWishlistGroupResponse[] | null
}

export interface ICuratedSelectionRequest {
  provider: string
  key: string
}

export interface ISaveWishlistArgs {
  wishlistMode: WishlistMode
  links: string[] | null
  curatedLinks: ICuratedSelectionRequest[] | null
}

export interface IWishlistSaveErrorItemResponse {
  detail?: string
  source?: {
    parameter?: string
    pointer?: string
  }
}

export interface IWishlistSaveErrorResponse {
  message?: string
  errors?: IWishlistSaveErrorItemResponse[] | null
}
